const SvgIconUserSignIn = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0969 11.9482C14.5678 11.9482 16.571 9.94505 16.571 7.47408C16.571 5.00311 14.5678 3 12.0969 3C9.62592 3 7.6228 5.00311 7.6228 7.47408C7.6228 9.94505 9.62592 11.9482 12.0969 11.9482Z"
        fill="#514B4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99998 18.1708C4.9988 17.8563 5.06914 17.5456 5.20571 17.2623C5.63426 16.4052 6.84278 15.9509 7.8456 15.7452C8.56883 15.5909 9.30205 15.4878 10.0398 15.4367C11.4057 15.3167 12.7795 15.3167 14.1454 15.4367C14.883 15.4884 15.6162 15.5915 16.3396 15.7452C17.3424 15.9509 18.5509 16.3623 18.9795 17.2623C19.2541 17.8399 19.2541 18.5104 18.9795 19.088C18.5509 19.9879 17.3424 20.3993 16.3396 20.5965C15.6172 20.7572 14.8837 20.8632 14.1454 20.9136C13.0336 21.0078 11.9167 21.025 10.8026 20.965C10.5455 20.965 10.2969 20.965 10.0398 20.9136C9.30423 20.8638 8.57355 20.7578 7.85417 20.5965C6.84278 20.3993 5.64283 19.9879 5.20571 19.088C5.06984 18.8013 4.99956 18.488 4.99998 18.1708Z"
        fill="#514B4D"
      />
    </svg>
  );
};

export default SvgIconUserSignIn;
